"use strict";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultOptions = exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _immutable = require("immutable");
var _constants = require("../constants");
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}
var defaultOptions = exports.defaultOptions = {
  title: null,
  closable: true,
  closeLabel: 'Close',
  closeX: true,
  closeXAbsolute: false,
  closeButton: true,
  closeUnderlay: true,
  onClose: null,
  size: null,
  draggable: true,
  containsForm: false,
  actionButtons: null,
  titleSize: null,
  padding: null,
  paddingBottom: null,
  rounded: true,
  border: null,
  headerClasses: null,
  minWidth: null,
  ariaLevel: null,
  headerStyles: {},
  coverScreen: false
};
var Modal = /*#__PURE__*/_createClass(function Modal() {
  var _this = this;
  _classCallCheck(this, Modal);
  this.defaultOptions = defaultOptions;
  this.modalOpen = function (content, options) {
    return function (dispatch) {
      var validContentTypes = ['string'];
      if (!validContentTypes.includes(_typeof(content)) && ! /*#__PURE__*/_react.default.isValidElement(content)) {
        console.warn('Invalid content provided to modalOpen: ', _typeof(content), content);
        return;
      }
      var payload = _objectSpread({
        content: content
      }, _this.defaultOptions);
      switch (_typeof(options)) {
        case 'string':
          // Allow a string to be passed for the title
          payload.title = options;
          break;
        case 'object':
          // Only allow options that are included in defaultOptions
          Object.keys(_this.defaultOptions).forEach(function (key) {
            if (Object.prototype.hasOwnProperty.call(options, key) && options[key] !== null) {
              if (Array.isArray(options[key])) {
                payload[key] = (0, _immutable.List)(options[key]);
              } else {
                payload[key] = options[key];
              }
            }
          });
          break;
        case 'undefined':
          break;
        default:
          console.warn('Invalid options provided to modalOpen: ', _typeof(options), options);
          return;
      }
      dispatch({
        type: _constants.MODAL_OPEN,
        payload: payload
      });
    };
  };
  this.modalClose = function () {
    return {
      type: _constants.MODAL_CLOSE
    };
  };
});
var _default = exports.default = Modal;